export const removeDuplicatesFromArray = (array) => {
  return array.filter((obj, index, self) => {
    return index === self.findIndex((t) => (
      t.label === obj.label
    ));
  });
}